import { useCallback } from 'react'
import type { SaveData } from '@/data/save'

const SAVE_KEY = 'aquavision_save'

export function useSaveSystem() {
  const save = useCallback((data: SaveData) => {
    const saveData = { ...data, updatedAt: new Date().toISOString() }
    localStorage.setItem(SAVE_KEY, JSON.stringify(saveData))
    return saveData
  }, [])

  const load = useCallback((): SaveData | null => {
    const raw = localStorage.getItem(SAVE_KEY)
    if (!raw) return null
    try {
      return JSON.parse(raw)
    } catch {
      return null
    }
  }, [])

  const deleteSave = useCallback(() => {
    localStorage.removeItem(SAVE_KEY)
  }, [])

  const hasSave = useCallback((): boolean => {
    return localStorage.getItem(SAVE_KEY) !== null
  }, [])

  return { save, load, deleteSave, hasSave }
}